<template>
    <div id="perform" class="section">
        <span v-if="language==='EN'">
            <PageTitle :title="'Performances'" :subtitle="'Oksanas\' live video performances'" :description="description_EN" />                      
        </span>
        <span v-if="language==='RU'">
            <PageTitle :title="'Выступления'" :subtitle="'Видео выступлений Оксаны'" :description="description_RU" />                               
        </span>
        <span v-if="language==='UA'">
            <PageTitle :title="'Виконання творiв'" :subtitle="'Вiдео виступiв Оксани'" :description="description_UA" />                             
        </span>

        <Videos :videos="Videos" />
    </div>

</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    import Videos from '@/components/Videos'
    import Performances from '@/data/performances.json'

    export default {
        components: { PageTitle, Videos },
        data: () => ({
            language: '',
            description_RU: '',
            description_EN: '',
            description_UA: '',                        
            Videos: []
        }),
        mounted(){
            this.language = MyFunctions.getLanguage()
        },
        created(){
            this.getVideos()
        },
        methods: {
            getVideos() {
                this.Videos = Performances
            }
        }
    }
</script>

<style>
    #perform p {
        color: #666!important;
    }
    #perform .title {
        color: #000!important;
    }
</style>
